<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-calculator"></i>
        <div class="mg-l-20">
          <h4>{{ $t("other.其他支出流水管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success"
          type="button"
          v-if="isSysRights('Profit.addOtherCostFlow')"
          @click="createCostFlow"
        >
          {{ $t("other.添加支出流水") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyDateFrom"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('dateFrom')"
        >
          {{ $t("other.起始日期：") }}
          <span class="mg-r-10">{{ keyDateFrom }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyDateTo"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('dateTo')"
        >
          {{ $t("other.截止日期：") }}
          <span class="mg-r-10">{{ keyDateTo }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("other.状态：") }}
          <span class="mg-r-10">{{ $dict.costFlowStatus[keyStatus] }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyDateFrom", "keyDateTo", "keyStatus"],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    createCostFlow() {
      this.$emit("createCostFlow");
    },
  },
};
</script>